module.exports = __webpack_public_path__ + "static/media/md.74766d5e.svg";